<h3>{{ 'Hey' | translate }} {{ partner.firstName }}</h3>
<p>{{ 'Thank you for being with us!' | translate }}</p>
<div class="row">
  <div class="col-12 user-box">
    <div>
      <b>ID:</b> {{ partner.ref }}
    </div>
    <div class="user-box-image">
      <svg height="80" width="80" (click)="myProfileClick()">
        <circle cx="40" cy="40" r="35" stroke="#FFFFFF" stroke-width="3" fill="none"></circle>
      </svg>
    </div>
    <div>
      <a (click)="myChildrenClick()">{{ 'My children' | translate }}</a>
    </div>
    <div>
      <a (click)="bookingOverviewClick()">{{ 'Booking overview' | translate }}</a>
    </div>
    <div>
      <a [attr.href]="partner.waiverUrl" target="_blank">{{ 'Liability Statement' | translate }}</a>
    </div>
    <div>
      <a (click)="deleteAccountClick()">{{ 'Delete account' | translate }}</a>
    </div>
  </div>
</div>
